
import React from 'react';
import ZNetwork from "./znetwork.js";
import ZLog from "./zlog.js";
import ZUtil from "./zutil.js";
import { APP } from "./App.js";
import AMC from './AMC';
import AMCForm from './AMCForm';
import PleaseStandBy from "./PleaseStandBy.js";
import ZooGenericTrackedButton from './ZooGenericTrackedButton';
import ZooErrorFoundPage from "./ZooErrorFoundPage.js";
import AMCConstants from "./AMCConstants.js";
import LICENSES from "./licenses";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

export default class ZooGotDataPage extends React.Component {
	constructor(props) {
		super(props);
		let cookies = JSON.parse(ZUtil.getCandy("gotdata") || "{}");
		this.state = { task: cookies.task || "register", format: cookies.format || "CSV", values: cookies || {} };
	}
	componentDidMount() {
		APP.setTitle("Got Data?");
		AMC.track(AMCConstants.GOT_DATA_TRACKING_URI);
	}
	componentWillUnmount() {
		APP.setTitle(null);
	}
	onInvalidChange = (properties) => {
		ZUtil.setCandy("gotdata", properties);
		if (properties.task !== this.state.task || this.state.enabled) {
			this.setState({ task: properties.task, enabled: false }); 
		}
	}
	onChange = (properties) => {
		ZUtil.setCandy("gotdata", properties);
		if (properties.task !== this.state.task || !this.state.enabled) {
			this.setState({ task: properties.task, enabled: true }); 
		}
	}
	onMore = (e) => {
		e.preventDefault();
		this.setState({ file: null, state: null, values: { ...this.state.values, upload: null, name: null } });
	}
	onUploading = (file, callback) => {
		this.setState({ file: file, values: { ...this.state.values, upload: file.name } });
	}
	onSave = (properties) => {
		let { task, format, file } = this.state;
		properties.kind = "dataset";
		properties.published = true;
		properties.supervised = true;
		properties.type = "core/datasource/ATM" + ZUtil.capitalize(format) + (properties.labelsource ? "Supervised" : "") + "DataSource";
		this.setState({ state: "saving" });
		delete properties.task;
		ZLog.debug("ZooGotDataPage.onSave create: ", { properties: properties});
		AMC.create(properties, (err, newthing) => {
			if (err) {
				return this.setState({ state: "error", error: err });
			}
			if (task === "upload") {
				ZNetwork.post("upload", { filename: file.name, properties: newthing, filetype: file.type }, (err, data) => {
					if (err) {
						return this.setState({ state: "error", error: err });
					}
					ZNetwork.uploadToS3(file, data.signed_request, (err, filename) => {
						ZLog.debug("Uploading to S3 complete: " + filename);
						if (err) {
							return this.setState({ state: "error", error: err });
						}
						newthing.url = "s3:" + newthing.uri;
						AMC.save(newthing);
						AMC.track(AMCConstants.GOT_DATA_SAVE_TRACKING_URI);
						this.setState({ saved_uri: newthing.uri, state: "saved" });
					});
				});
			} else {
				AMC.track(AMCConstants.GOT_DATA_SAVE_TRACKING_URI);
				this.setState({ state: "saved", saved_uri: newthing.uri });
			}
		});
	}
	render() {
		let { task, values, error, state, saved_uri, enabled } = this.state;

		var fields = [];
		switch (task) {
			case "register" :
				fields = [
					{ name: "Task", field: "task", kind: "radio", required: true, "default": "register", choices: ["register", "upload"], hint: "Do you want to register the url of the dataset or do you want to upload the dataset from your PC to the server" },
					{ name: "Format", field: "format", kind: "radio", required: true, "default": "CSV", choices: ["CSV", "images", "video"]},
					{ name: "Name", field: "name", kind: "string", minlen: 8, maxlen: 64, placeholder: "", required: true },
					{ name: "Description", field: "description", kind: "text", minlen: 0, maxlen: 4096, placeholder: "(suggested) description", required: false },
					{ name: "Size", field: "size", kind: "string", minlen: 4, maxlen: 256, placeholder: "Size of dataset", required: false },
					{ name: "Attribution", field: "attribution", kind: "string", minlen: 3, maxlen: 256, placeholder: "Attribution", required: false },
					{ name: "Training data", field: "datasource", kind: "url", minlen: 12, maxlen: 256, placeholder: "Link to training data", required: true },
					{ name: "Training labels", field: "labelsource", kind: "url", minlen: 12, maxlen: 256, placeholder: "(optional) Link to training labels", required: false },
					{ name: "Permissions", field: "permissions", kind: "radio", required: false, choices: ["public", "private"] },
					{ name: "License", field: "license", kind: "menu", choices: LICENSES.map(x => x[0]), "default": "MIT (mit)", hint: "The license that applies when public" },
					{ name: "Thumbnail", field: "thumb", kind: "cloudinary", folder: "things", size: "thumb", label: "Upload image", hint: "(optional) Image representative of data", required: false, enabled: enabled },
					]
				break;
			case "upload" :
				fields = [
					{ name: "Task", field: "task", kind: "radio", required: true, "default": "register", choices: ["register", "upload"], hint: "Whther to register url of dataset or upload dataset from you PC to the server" },
					{ name: "Format", field: "format", kind: "radio", required: true, "default": "CSV", choices: ["CSV", "images", "video"]},
					{ name: "Name", field: "name", kind: "string", minlen: 8, maxlen: 64, placeholder: "", required: true },
					{ name: "Description", field: "description", kind: "text", minlen: 0, maxlen: 4096, placeholder: "(suggested) description", required: false },
					{ name: "Size", field: "size", kind: "string", minlen: 4, maxlen: 256, placeholder: "Size of dataset", required: false },
					{ name: "Attribution", field: "attribution", kind: "string", minlen: 3, maxlen: 256, placeholder: "Attribution", required: false },
					{ name: "Permissions", field: "permissions", kind: "radio", required: false, choices: ["public", "private"] },
					{ name: "License", field: "license", kind: "menu", choices: LICENSES.map(x => x[0]), "default": "MIT (mit)", hint: "The license that applies when public" },
					{ name: "Thumbnail", field: "thumb", kind: "cloudinary", folder: "things", size: "thumb", label: "Upload image", hint: "(optional) Image representative of data", required: false, enabled: enabled },
					{ name: "Data", field: "upload", kind: "upload", required: true, enabled: enabled },
					]
				break;
			default: 
				break;
		}
		let suggestions = 
			<div className="ZooSearchPageServicesSuggestions">
				<a href={"/search/is:service"}>all services</a>
				<a href={"/search/is:algorithms"}>all algorithms</a>
				<a href={"/search/is:datasource"}>all data</a>
			</div>
		return (
			<div className="ZooGeneralPage ZooGotPage"> 
				<div className="ZooGeneralPageHeader">
					{ error ?  <div style={{opacity: 0.2}}><ZooErrorFoundPage /></div> : <h1>Got data?</h1> }
				</div>
				{ state === "saved" ?
					<AMCForm fields={fields} values={values} buttons={
						<span>
							<FontAwesomeIcon style={{color: "#0a0"}} icon={faCheck} /> 
							Saved to <a href={"/zoo/" + saved_uri}>{saved_uri}</a>
							<button className="AMCButton" href="" onClick={this.onMore}>Got another?</button>
						</span> } 
					/>
				:
					<AMCForm key={task} fields={fields} values={values} onChange={this.onChange} onInvalidChange={this.onInvalidChange} onSave={this.onSave} saveButton={ <ZooGenericTrackedButton label={task === "register" ? "Register Data" : "Upload Data"} tracking_uri={AMCConstants.GOT_DATA_SAVE_TRACKING_URI} callback={this.onSave} />} onUploading={this.onUploading}  />
				}
				{suggestions}
				{ state === "loading" || state === "saving" ? <PleaseStandBy /> : '' }
			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/ZooGotDataPage.js